module.exports = __webpack_public_path__ + "img/Guirlande.d0d5e9a.png";